import FileSaver from 'file-saver';
import {
  action,
  observable,
} from 'mobx';
import {
  RequestStatus,
} from 'mobx-store';
import {
  downloadAllUsersFacebookInfo,
  getPaginatedFacebookInfoList,
} from '../../axios/statistics';
import Connections from '../../connections';
import {
  IFacebookInfoStore,
  UserFacebookInfo,
} from '../storeInterfaces/facebookInfoInterface';

export class FacebookInfoStore implements IFacebookInfoStore {
  @observable usersFBInfoList: UserFacebookInfo[] = [];

  @observable totalNumberOfUsers = -1;

  @observable loading = false;

  @observable getFBInfoListRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getPaginatedFacebookInfoList(pageNumber: number, pageSize: number): Promise<void> {
    try {
      this.loading = true;
      this.getFBInfoListRequestStatus = RequestStatus.LOADING;
      const params = {
        pageNumber,
        pageSize,
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getPaginatedFacebookInfoList, {
        params,
      });

      this.usersFBInfoList = response?.facebookUsers;
      this.totalNumberOfUsers = response?.count;
      this.getFBInfoListRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getFBInfoListRequestStatus = RequestStatus.FAILED;
      console.log(error);
      throw Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  // eslint-disable-next-line consistent-return
  public async downloadFacebookUsersSheet(): Promise<void> {
    try {
      this.loading = true;

      const response = await Connections.wadiDeglaAxios.httpGet(downloadAllUsersFacebookInfo, {
        responseType: 'blob',
      });
      await FileSaver.saveAs(response, 'facebook-info');
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }
}
